import script from "./map2.vue?vue&type=script&setup=true&lang=js"
export * from "./map2.vue?vue&type=script&setup=true&lang=js"

import "./map2.vue?vue&type=style&index=0&id=44fe9ab8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44fe9ab8"]])

export default __exports__